import React, { useEffect, useState } from 'react'
import { userMobileSchema } from '../../../schema/loginSchema'
import { Images } from '../../../assets/scripts/Images'
import { errorList, input_class, position_center } from '../../../functions/stateList'
import { useDispatch, useSelector } from 'react-redux'
import { mobileSubmitForm } from '../../../functions/userLogin'
import { useNavigate } from 'react-router-dom'
import { notAllowEnterNumber } from '../../../assets/scripts/GeneralFunctions'

function UserLoginRightSection() {
  const [mobile, setMobile] = useState('')
  const [error, setError] = useState({
    mobile: '',
  })
  const [isSubmit, setIsSubmit] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  let user_mobile = useSelector((state) => state?.mobileReducer?.mobile)
  useEffect(() => {
    setMobile(user_mobile)
  }, [user_mobile])

  const inputHandler = (e) => {
    setMobile(e.target.value)
    setError({ ...error, [e.target.name]: '' })
  }

  const loginSubmit = (e) => {
    e.preventDefault()
    setIsSubmit(true)
    userMobileSchema
      .validate({ mobile }, { abortEarly: false })
      .then(async function () {
        setIsSubmit(true)
        await mobileSubmitForm(navigate, dispatch, mobile, setError, null)
        setIsSubmit(false)
      })
      .catch(function (err) {
        setError({
          ...error,
          ...errorList(err),
        })
      })

    setIsSubmit(false)
  }

  return (
    <div className={'w-full lg:w-1/2 h-screen relative'}>
      <img
        src={Images.shape_logo}
        width={460}
        height={420}
        className={'hidden lg:block absolute -top-36 right-0'}
        alt="milani logo"
      />
      <form onSubmit={loginSubmit} className={`${position_center} w-[300px]`}>
        <img
          src={Images.logo}
          width={250}
          height={200}
          className={'lg:hidden mb-12 mx-auto'}
          alt="milani logo"
        />
        <label className={'font-normal text-md dark:text-slate-200'} htmlFor="mobile">
          تلفن همراه
        </label>
        <input
          className={`${input_class} mt-2 ${error?.mobile ? 'mb-2' : 'mb-10'}`}
          onKeyPress={(e) => notAllowEnterNumber(e, 11)}
          type="number"
          min="0"
          inputMode="numeric"
          pattern="[0-9]*"
          name={'mobile'}
          id={'mobile'}
          required
          value={mobile}
          onChange={inputHandler}
          placeholder={'شماره تلفن همراه را وارد کنید'}
        />
        {error?.mobile && <p className={'text-rose-500 mb-8'}>{error?.mobile}</p>}

        {error && typeof error === 'string' && <p className={'text-rose-500 mb-8'}>{error}</p>}
        <button
          disabled={error.mobile || isSubmit}
          type={'submit'}
          className={'w-full text-white bg-blue rounded-md h-11 shadow-add-more text-md'}
        >
          {isSubmit ? 'در حال بررسی اطلاعات' : 'ورود'}
        </button>
      </form>

      <div className={`${position_center} w-[300px] lg:w-fit top-[80%] lg:top-[70%]`}>
        <div className="flex items-center text-lg gap-3 mb-3">
          <span className="icon-location text-gray-700 dark:text-amber-100"></span>
          <p className="text-gray-700 dark:text-amber-100">تبریز، خیابان پاستور، تقاطع قطران</p>
        </div>
        <div className="flex items-center text-lg gap-3 mb-3">
          <span className="icon-call text-gray-700 dark:text-amber-100"></span>
          <a href="tel:09148027757" className="text-gray-700 dark:text-amber-100">
            09148027757
          </a>
        </div>
        {/*<div className="flex items-center text-lg gap-3 mb-3">*/}
        {/*  <span className="icon-insta text-gray-700 dark:text-amber-100"></span>*/}
        {/*  <a target='_blank' rel="noreferrer" href='https://instagram.com/milani_autoclinic' className='text-gray-700 dark:text-amber-100 uppercase'>milani_autoclinic</a>*/}
        {/*</div>*/}
      </div>
    </div>
  )
}

export default UserLoginRightSection
